import { render } from "./Result.vue?vue&type=template&id=924c1504&scoped=true"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"

import "./Result.vue?vue&type=style&index=0&id=924c1504&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-924c1504"

export default script